<template>
    <!-- Home button -->
    <span class="icon-link">
        <ScrollTo href="#home" offset="100" class="scroll-link" @click="openMobileMenu">
            <img class="icon" src="@/assets/navbar/home_icon.png" alt="Icon">
            <span class="navbar-text">{{ $t('navbar.home') }}</span>
        </ScrollTo>
    </span>

    <!-- Professional Projects button -->
    <span class="icon-link">
        <ScrollTo href="#professional-projects" offset="100" class="scroll-link" @click="openMobileMenu">
            <img class="icon" src="@/assets/navbar/professional_icon.png" alt="Icon">
            <span class="navbar-text">{{ $t('navbar.professional-projects') }}</span>
        </ScrollTo>
    </span>

    <!-- Personal Projects button -->
    <span class="icon-link">
        <ScrollTo href="#personal-projects" offset="100" class="scroll-link" @click="openMobileMenu">
            <img class="icon" src="@/assets/navbar/personal_icon.png" alt="Icon">
            <span class="navbar-text">{{ $t('navbar.personal-projects') }}</span>
        </ScrollTo>
    </span>

    <!-- About button -->
    <span class="icon-link">
        <ScrollTo href="#about" offset="100" class="scroll-link" @click="openMobileMenu">
            <img class="icon" src="@/assets/navbar/about_icon.png" alt="Icon">
            <span class="navbar-text">{{ $t('navbar.about') }}</span>
        </ScrollTo>
    </span>

    <!-- Contact button -->
    <span class="icon-link">
        <ScrollTo href="#contact" offset="100" class="scroll-link" @click="openMobileMenu">
            <img class="icon" src="@/assets/navbar/contact_icon.png" alt="Icon">
            <span class="navbar-text">{{ $t('navbar.contact') }}</span>
        </ScrollTo>
    </span>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";
import ScrollTo from '@/components/Helpers/ScrollTo.vue';

const props = defineProps({
    isOpen: Boolean,
});

// Emissor de eventos
const emit = defineEmits(['update:isOpen']);

function openMobileMenu() {
    emit('update:isOpen', !props.isOpen);
}
</script>

<style lang="scss" scoped>
@import '~/src/assets/css/NavbarStyle.scss';
</style>